module.exports = __webpack_public_path__ + "static/34-29db0d0cff520c6a76b23916c0258725.png";